import { render } from "./adp-config.vue?vue&type=template&id=7e2e5226&ts=true"
import script from "./adp-config.vue?vue&type=script&lang=ts"
export * from "./adp-config.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__